import styled from 'styled-components';
import {device} from 'styled/device';

export const StyledCaseHeader = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  align-items: center;
  padding-bottom: 40px;

  .caseHeaderFirstMobileLine {
    display: flex;
  }

  .mobileBackButton {
    display: none;
  }

  .caseHeaderTitle {
    font-size: 44px;
    font-weight: 500;
    color: #23262f;
  }

  .caseHeaderButtons {
    display: flex;
    gap: 20px;
  }

  @media (max-width: ${device.mobileXL}) {
    gap: 15px;
    flex-direction: column;
    margin-top: 10px;

    .caseHeaderFirstMobileLine {
      align-self: flex-start;
    }

    .caseHeaderFirstMobileLine {
      align-self: flex-start;
    }

    .mobileBackButton {
      display: flex;
      width: 30px;
      height: 100%;
      cursor: pointer;
      padding: 10px 5px 5px 5px;
    }

    .caseHeaderTitle {
      font-size: 26px;
      font-weight: 400;
      margin-left: 1rem;
    }

    .caseHeaderButtons {
      /* display: none; */
    }
  }
`;
